export { default } from "./Menu.page";
